import { render, staticRenderFns } from "./BtnAtesto.vue?vue&type=template&id=27d027a2&"
import script from "./BtnAtesto.vue?vue&type=script&lang=js&"
export * from "./BtnAtesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports